import { render, staticRenderFns } from "./TrRectangle.vue?vue&type=template&id=23d06ed4&scoped=true&"
import script from "./TrRectangle.vue?vue&type=script&lang=js&"
export * from "./TrRectangle.vue?vue&type=script&lang=js&"
import style0 from "./TrRectangle.vue?vue&type=style&index=0&id=23d06ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d06ed4",
  null
  
)

export default component.exports